"use strict";
exports.__esModule = true;
exports.fromElrondResourcesRaw = exports.toElrondResourcesRaw = void 0;
function toElrondResourcesRaw(r) {
    var nonce = r.nonce, delegations = r.delegations;
    return {
        nonce: nonce,
        delegations: delegations
    };
}
exports.toElrondResourcesRaw = toElrondResourcesRaw;
function fromElrondResourcesRaw(r) {
    var nonce = r.nonce, delegations = r.delegations;
    return {
        nonce: nonce,
        delegations: delegations
    };
}
exports.fromElrondResourcesRaw = fromElrondResourcesRaw;
//# sourceMappingURL=serialization.js.map